(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('end-customer', {
            parent: 'entity',
            url: '/end-customer?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.endCustomer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/end-customer/end-customers.html',
                    controller: 'EndCustomerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('endCustomer');
                    $translatePartialLoader.addPart('practitionerSalutation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('end-customer-detail', {
            parent: 'end-customer',
            url: '/end-customer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.endCustomer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/end-customer/end-customer-detail.html',
                    controller: 'EndCustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('endCustomer');
                    $translatePartialLoader.addPart('practitionerSalutation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EndCustomer', function($stateParams, EndCustomer) {
                    return EndCustomer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'end-customer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('end-customer-detail.edit', {
            parent: 'end-customer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/end-customer/end-customer-dialog.html',
                    controller: 'EndCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EndCustomer', function(EndCustomer) {
                            return EndCustomer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('end-customer.new', {
            parent: 'end-customer',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/end-customer/end-customer-dialog.html',
                    controller: 'EndCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstname: null,
                                lastname: null,
                                phone: null,
                                salutation: null,
                                addressStreet: null,
                                addressStreetNumber: null,
                                addressCity: null,
                                addressPostalCode: null,
                                email: null,
                                dateOfBirth: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('end-customer', null, { reload: 'end-customer' });
                }, function() {
                    $state.go('end-customer');
                });
            }]
        })
        .state('end-customer.edit', {
            parent: 'end-customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/end-customer/end-customer-dialog.html',
                    controller: 'EndCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EndCustomer', function(EndCustomer) {
                            return EndCustomer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('end-customer', null, { reload: 'end-customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('end-customer.delete', {
            parent: 'end-customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/end-customer/end-customer-delete-dialog.html',
                    controller: 'EndCustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EndCustomer', function(EndCustomer) {
                            return EndCustomer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('end-customer', null, { reload: 'end-customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
